import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { fetchPersonalNotes, fetchPersonalNote } from '../../actions';
// import BookLink from './book-link';

class Collection extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
  }

  componentDidMount() {
    this.props.fetchPersonalNotes();
  }

  handleClickCollectionItem = (personalNoteID) => {
    this.props.setPersonalNoteID(personalNoteID);
  }

  render() {
    return (
      <div className="collection">
        {this.props.personalNotes.map((personalNote) => {
          return (
            <div key={personalNote.id} className="saved-story">
              <p onClick={() => this.handleClickCollectionItem(personalNote.id)}>{personalNote.Page?.title}</p>
            </div>
          );
        })}
      </div>
    );
  }
}

// connects particular parts of redux state to this components props
const mapStateToProps = (state) => (
  {
    personalNotes: state.personalNotes.all,
  }
);

// react-redux glue -- outputs Container that know state in props
// also with an optional HOC withRouter
// export default withRouter(connect(mapStateToProps, { fetchChapters, fetchBook })(TableOfContents));

export default withRouter(connect(mapStateToProps, { fetchPersonalNotes, fetchPersonalNote })(Collection));
